import { getStory } from '@/lib/storyblok'
import { BlokProps } from '@/lib/types'
import { IncludeSnippetStoryblok, SnippetStoryblok } from '@/lib/types/component-types-sb'
import { Snippet } from './snippet'

export async function IncludeSnippet({ blok }: BlokProps<IncludeSnippetStoryblok>) {
  const snippet = blok.snippet?.at(0)

  if (!snippet) {
    return null
  }

  const snippetStory = await getStory<SnippetStoryblok>(snippet as string, [], false, {}, true)

  return <Snippet blok={snippetStory.content} />
}
